import { createFileRoute, redirect } from '@tanstack/react-router';
import { AdminLoginPage } from '../pages/auth/login-page';
import { isAuthenticated, mustResetPassword } from '../auth/session';

export const Route = createFileRoute('/login')({
  beforeLoad: () => {
    if (isAuthenticated()) {
      throw redirect({ to: mustResetPassword() ? '/change-password' : '/contests' });
    }
  },
  component: AdminLoginPage,
});
